export default __webpack_public_path__ + "static/media/My project (83) 3 (1).e58081f7.png";